import Icon from '../components/Icon.vue'

Icon.register({"briefcase":{"width":1792,"height":1792,"paths":[{"d":"M640 256h512v-128h-512v128zM1792 896v480q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-480h672v160q0 26 19 45t45 19h320q26 0 45-19t19-45v-160h672zM1024 896v128h-256v-128h256zM1792 416v384h-1792v-384q0-66 47-113t113-47h352v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h352q66 0 113 47t47 113z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/briefcase.js
// module id = 389
// module chunks = 0